<div class="wizard-v2">
  <!-- Header -->
  <div class="wizard-header">
    <div class="wizard-header-inner">
      <div class="wizard-header-left">
        <img src="/assets/icons/logo-meucardapio.png" alt="MeuCardápio.ai" class="wizard-logo-img">
        <div class="wizard-header-titulos">
          <span class="wizard-header-titulo">Meu Cardápio</span>
          <span class="wizard-header-subtitulo">CONFIGURAÇÃO INICIAL</span>
        </div>
      </div>
      <div class="wizard-header-right" *ngIf="passoAtual !== 'welcome'">
        <div class="wizard-progress-copy">
          <span class="wizard-progress-overline">PROGRESSO</span>
          <span class="wizard-progress-label">Passo {{ state.passoAtualIndex }} de {{ state.passosAtivos.length - 1 }}</span>
        </div>
        <div class="wizard-progress-bar">
          <div class="wizard-progress-fill" [style.width.%]="progresso"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Layout: conteúdo centralizado -->
  <div class="wizard-body">
    <div class="wizard-main">
      <!-- Conteúdo -->
      <div class="wizard-content" [ngClass]="animacao">

      <div class="alert alert-danger" *ngIf="erroPersistencia && passoAtual !== 'modo-venda'">
        <i class="fe-alert-circle mr-1"></i> {{ erroPersistencia }}
      </div>

      <!-- Step: Welcome -->
      <app-step-welcome
        *ngIf="passoAtual === 'welcome'"
        (onComecar)="avance()">
      </app-step-welcome>

      <!-- Step: Caminho de entrada (inclui ifood-pergunta e caminhos) -->
      <app-step-caminho-entrada
        *ngIf="passoAtual === 'caminho-entrada' || passoAtual === 'ifood-pergunta' || passoAtual === 'caminhos'"
        [empresa]="empresa"
        [fase]="passoAtual"
        (onVoltar)="volte()"
        (onAvancar)="avance()"
        (onEscolhido)="onCaminhoEscolhido($event)"
        (onImportacaoConcluida)="onImportacaoConcluida($event)">
      </app-step-caminho-entrada>

      <!-- Step: Dados da loja -->
      <app-step-boas-vindas
        *ngIf="passoAtual === 'boas-vindas'"
        [nomeInicial]="state.nomeEmpresa"
        [segmentoInicial]="state.segmento"
        [caminhoEscolhido]="state.caminhoEscolhido"
        [empresa]="empresa"
        [logoAtual]="state.logoUrl"
        (onVoltar)="volte()"
        (onConcluido)="onBoasVindas($event)">
      </app-step-boas-vindas>

      <!-- Step: Importação -->
      <app-step-importacao
        *ngIf="passoAtual === 'importacao'"
        [empresa]="empresa"
        (onConcluido)="onImportacaoConcluida($event)"
        (onVoltar)="volte()">
      </app-step-importacao>

      <!-- Step: Subdomínio -->
      <app-step-subdominio
        *ngIf="passoAtual === 'subdominio'"
        [subdominioInicial]="state.subdominio"
        [empresa]="empresa"
        (onConcluido)="onSubdominioConcluido($event)"
        (onVoltar)="volte()">
      </app-step-subdominio>

      <!-- Step: Modo de Venda -->
      <app-step-modo-venda
        *ngIf="passoAtual === 'modo-venda'"
        [modosAtuais]="state.modosDeVenda"
        [salvando]="carregando"
        [erroPersistencia]="erroPersistencia"
        (onConcluido)="onModoVendaSelecionado($event)"
        (onVoltar)="volte()">
      </app-step-modo-venda>

      <!-- Step: Produtos -->
      <app-step-produtos
        *ngIf="passoAtual === 'passo-produtos'"
        [caminhoEscolhido]="state.caminhoEscolhido"
        [produtosImportados]="state.produtosImportados"
        [produtosTemplate]="state.produtosTemplate"
        [produtosManuais]="state.produtosManuais"
        [categoriasImportadas]="state.categoriasImportadas"
        [empresa]="empresa"
        (onConcluido)="onProdutosConcluidos()"
        (onVoltar)="volte()">
      </app-step-produtos>

      <!-- Step: Tema -->
      <app-step-tema
        *ngIf="passoAtual === 'tema'"
        [empresa]="empresa"
        [temaSelecionadoInicial]="state.temaSelecionado"
        (onConcluido)="onTemaSelecionado($event)"
        (onVoltar)="volte()"
        (onPular)="avance()">
      </app-step-tema>

      <!-- Step: Conclusão -->
      <app-step-conclusao
        *ngIf="passoAtual === 'conclusao'"
        [state]="state"
        [empresa]="empresa"
        (onConcluir)="onConcluir()">
      </app-step-conclusao>

      </div>
    </div>
  </div>

</div>
